module.exports = __webpack_public_path__ + "img/anm22logo.13dc6be6.png";